import React, { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';

// const DonutChart = () => {
//   const chartRef = useRef(null);

//   useEffect(() => {
//     const chart = new ApexCharts(chartRef.current, {
//       series: [72, 26, 12, 8],
//       chart: {
//         height: 350,
//         type: 'donut',
//         toolbar: {
//           show: true
//         }
//       },
//       labels: ['0 - 3 Days    72(56%)', '3 - 5 Days   26(20%)', '5 - 7 Days   12(10%)', ' > 7 Days   8(14%)'],
//     });

//     chart.render();

//     return () => {
//       chart.destroy();
//     };
//   }, []);

//   return <div id="donutChart" ref={chartRef}></div>;
// };

// export default DonutChart;


// import React, { useEffect, useRef } from 'react';
// import ApexCharts from 'apexcharts';

// const DonutChart = () => {
//   const chartRef = useRef(null);

//   useEffect(() => {
//     // 1. Defining the configuration options
//     const options = {
//       // Data series (raw numbers)
//       series: [72, 26, 12, 8],

//       // Basic Chart Settings
//       chart: {
//         type: 'donut',
//         height: 380,
//         width: '100%', // Makes it responsive to its container
//         background: 'transparent', // Can change to hex/rgba colors
//         fontFamily: 'Helvetica, Arial, sans-serif',
//         animations: {
//           enabled: true,
//           easing: 'easeinout',
//           speed: 800,
//           animateGradually: {
//             enabled: true,
//             delay: 150
//           },
//           dynamicAnimation: {
//             enabled: true,
//             speed: 350
//           }
//         },
//         toolbar: {
//           show: true, // Allows downloading as SVG/CSV/PNG
//           offsetX: 0,
//           offsetY: 0,
//           tools: {
//             download: true,
//             selection: false,
//             zoom: false,
//             zoomin: false,
//             zoomout: false,
//             pan: false,
//             reset: false
//           },
//         }
//       },

//       // Custom Color Palette (Hex codes)
//       colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560'],

//       // Labels corresponding to the data series
//       labels: ['0 - 3 Days', '3 - 5 Days', '5 - 7 Days', '> 7 Days'],

//       // Theme settings (Light vs Dark mode)
//       theme: {
//         mode: 'light', // 'light' or 'dark'
//         palette: 'palette1', // ApexCharts pre-defined palettes (palette1 to palette10)
//       },

//       // Data Labels (Text drawn directly ON the chart slices)
//       dataLabels: {
//         enabled: true,
//         formatter: function (val, opts) {
//           // 'val' is the automatically calculated percentage
//           // 'opts.w.globals.series[opts.seriesIndex]' gets the raw value (e.g., 72)
//           const rawValue = opts.w.globals.series[opts.seriesIndex];
//           return `${rawValue} (${val.toFixed(0)}%)`;
//         },
//         dropShadow: {
//           enabled: false,
//         },
//         style: {
//           fontSize: '12px',
//           fontWeight: 'bold',
//           colors: ['#fff'] // Color of the text inside the slices
//         }
//       },

//       // Plot Options (Specific adjustments to the Donut shape/size)
//       // plotOptions: {
//       //   pie: {
//       //     customScale: 1,
//       //     donut: {
//       //       size: '65%', // Changes the thickness of the donut
//       //       background: 'transparent',
//       //       labels: {
//       //         show: true, // Shows the central total labels
//       //         name: {
//       //           show: true,
//       //           fontSize: '22px',
//       //           fontFamily: 'Helvetica, Arial, sans-serif',
//       //           fontWeight: 600,
//       //           color: '#373d3f',
//       //           offsetY: -10,
//       //         },
//       //         value: {
//       //           show: true,
//       //           fontSize: '16px',
//       //           fontFamily: 'Helvetica, Arial, sans-serif',
//       //           fontWeight: 400,
//       //           color: '#888',
//       //           offsetY: 16,
//       //           formatter: function (val) {
//       //             return val; // Custom format for the hovered/total value
//       //           }
//       //         },
//       //         total: {
//       //           show: true,
//       //           showAlways: true,
//       //           label: 'Total Days',
//       //           fontSize: '16px',
//       //           fontWeight: 600,
//       //           color: '#373d3f',
//       //           formatter: function (w) {
//       //             // Sums up all values in the series for the center total
//       //             return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
//       //           }
//       //         }
//       //       }
//       //     }
//       //   }
//       // },

//       plotOptions: {
//         pie: {
//           donut: {
//             labels: {
//               show: true,
//               total: {
//                 show: true,
//                 showAlways: true,
//                 label: 'Total Days',
//                 formatter: function (w) {
//                   // 1. Safely check if globals and seriesTotals exist
//                   const seriesTotals = w.globals?.seriesTotals;

//                   // 2. Fallback to the raw series array if globals aren't ready yet
//                   const series = seriesTotals || w.config?.series || [];

//                   // 3. Perform the reduce safely
//                   return series.reduce((a, b) => a + b, 0);
//                 }
//               }
//             }
//           }
//         }
//       },

//       // Legend Settings (The color keys/labels mapping)
//       legend: {
//         show: true,
//         position: 'bottom', // 'top', 'bottom', 'left', 'right'
//         horizontalAlign: 'center',
//         floating: false,
//         fontSize: '14px',
//         fontWeight: 400,
//         inverseOrder: false,
//         tooltipHoverFormatter: undefined,
//         customLegendItems: [],
//         offsetX: 0,
//         offsetY: 7,
//         markers: {
//           width: 12,
//           height: 12,
//           strokeWidth: 0,
//           radius: 12, // Makes markers round
//         },
//         itemMargin: {
//           horizontal: 10,
//           vertical: 5
//         },
//         onItemClick: {
//           toggleDataSeries: true // Clicking a legend item hides/shows that slice!
//         },
//         onItemHover: {
//           highlightDataSeries: true // Hovering a legend item highlights the slice
//         },
//       },

//       // Tooltip Settings (Popups when hovering over slices)
//       tooltip: {
//         enabled: true,
//         shared: false,
//         followCursor: true,
//         intersect: false,
//         inverseOrder: false,
//         fillSeriesColor: false, // If true, tooltip background matches slice color
//         theme: 'light',
//         style: {
//           fontSize: '12px',
//           fontFamily: undefined
//         },
//         y: {
//           formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
//             // Calculates percentage manually for the tooltip if needed
//             const total = series.reduce((a, b) => a + b, 0);
//             const percent = ((value / total) * 100).toFixed(1);
//             return `${value} Items (${percent}%)`;
//           },
//           title: {
//             formatter: (seriesName) => `${seriesName}:`,
//           },
//         },
//       },

//       // States (How slices behave on hover or click)
//       states: {
//         normal: {
//           filter: { type: 'none', value: 0 }
//         },
//         hover: {
//           filter: { type: 'lighten', value: 0.15 } // Brightens the slice on hover
//         },
//         active: {
//           allowMultipleDataPointsSelection: false,
//           filter: { type: 'darken', value: 0.35 } // Darkens the slice when clicked
//         },
//       },

//       // Responsive breakpoints (Override settings based on screen width)
//       responsive: [
//         {
//           breakpoint: 480, // For mobile devices
//           options: {
//             chart: {
//               height: 300
//             },
//             legend: {
//               position: 'bottom',
//               fontSize: '11px'
//             },
//             plotOptions: {
//               pie: {
//                 donut: {
//                   labels: {
//                     name: { fontSize: '16px' },
//                     value: { fontSize: '14px' }
//                   }
//                 }
//               }
//             }
//           }
//         }
//       ]
//     };

//     // Initialize and render the chart
//     const chart = new ApexCharts(chartRef.current, options);
//     chart.render();

//     // Clean up on component unmount
//     return () => {
//       chart.destroy();
//     };
//   }, []);

//   return (
//     <div style={{ width: '100%', maxWidth: '500px', margin: '0 auto' }}>
//       <div ref={chartRef}></div>
//     </div>
//   );
// };

// export default DonutChart;

// import React, { useEffect, useRef } from 'react';
// import ApexCharts from 'apexcharts';

// const DonutChart = () => {
//   const chartRef = useRef(null);

//   useEffect(() => {
//     const options = {
//       series: [72, 26, 12, 8],
//       chart: {
//         type: 'donut',
//         height: 380,
//         width: '100%',
//         toolbar: {
//           show: true
//         }
//       },
//       colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560'],
//       labels: ['0 - 3 Days', '3 - 5 Days', '5 - 7 Days', '> 7 Days'],

//       // We let ApexCharts automatically calculate percentages on the slices
//       dataLabels: {
//         enabled: true,
//         style: {
//           fontSize: '12px',
//           colors: ['#fff']
//         }
//       },

//       plotOptions: {
//         pie: {
//           donut: {
//             size: '65%',
//             labels: {
//               show: true,
//               name: {
//                 show: true,
//                 fontSize: '14px',
//                 fontFamily: 'Helvetica, Arial, sans-serif',
//                 fontWeight: 500,
//                 color: '#666',
//                 offsetY: 20,
//                 // showAlways: true,
//                 // label: 'Total Items',
//                 // This utilizes ApexCharts' built-in auto-sum engine instead of a custom function
//               },
//               value: {
//                 show: true,
//                 fontSize: '28px', // Makes the number large
//                 fontFamily: 'Helvetica, Arial, sans-serif',
//                 fontWeight: 700,  // Bolds the number (118)
//                 color: '#111',
//                 offsetY: -20, // Pulls the number up to the top
//                 formatter: function (val) {
//                   return val;
//                 }
//               }
//             },
//             total: {
//               show: true,
//               showAlways: true,
//               label: 'Total Items',
//               // Keep the styling configurations consistent
//               fontSize: '14px',
//               fontWeight: 500,
//               color: '#666',
//               formatter: function (w) {
//                 // Safely falls back to summing the config series array
//                 const series = w.globals.seriesTotals || w.config.series || [];
//                 return series.reduce((a, b) => a + b, 0);
//               }
//             }
//           }
//         },

//         // Simple, standard tooltip with zero custom javascript math
//         tooltip: {
//           enabled: true,
//           y: {
//             formatter: function (val) {
//               return `${val} Items`;
//             }
//           }
//         },

//         legend: {
//           position: 'bottom'
//         }
//       };

//       const chart = new ApexCharts(chartRef.current, options);
//       chart.render();

//       return() => {
//   chart.destroy();
// };
//   }, []);

// return (
//   <div style={{ width: '100%', maxWidth: '500px', margin: '0 auto' }}>
//     <div ref={chartRef}></div>
//   </div>
// );
// };

// export default DonutChart;



// import React, { useEffect, useRef } from 'react';
// import ApexCharts from 'apexcharts';

// const DonutChart = ({ data }) => {
//   const chartRef = useRef(null);
//   const chartInstance = useRef(null);

//   useEffect(() => {
//     if (!data || typeof data !== 'object' || !data["0-3 Days"] && !data["3-5 Days"] && !data["> 5 Days"]) {
//       return;
//     }

//     // Destroy previous chart instance if it exists
//     if (chartInstance.current) {
//       chartInstance.current.destroy();
//       chartInstance.current = null;
//     }

//     const options = {
//       series: [data["0-3 Days"] || 0, data["3-5 Days"] || 0, data["> 5 Days"] || 0],
//       chart: {
//         type: 'donut',
//         height: 380,
//         width: '100%',
//         toolbar: {
//           show: true
//         }
//       },
//       colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560'],
//       labels: ['0 - 3 Days', '3 - 5 Days', '> 5 Days'],

//       dataLabels: {
//         enabled: true,
//         style: {
//           fontSize: '10px',
//           colors: ['#fff']
//         }
//       },

//       plotOptions: {
//         pie: {
//           donut: {
//             size: '65%',
//             labels: {
//               show: true,
//               name: {
//                 show: true,
//                 fontSize: '14px',
//                 fontFamily: 'Helvetica, Arial, sans-serif',
//                 fontWeight: 500,
//                 color: '#666',
//                 offsetY: 20, // Moves "Total Items" down below the number
//               },
//               value: {
//                 show: true,
//                 fontSize: '28px', // Makes the number large
//                 fontFamily: 'Helvetica, Arial, sans-serif',
//                 fontWeight: 700,  // Bolds the number (118)
//                 color: '#111',
//                 offsetY: -20, // Pulls the number up to the top
//                 formatter: function (val) {
//                   return val;
//                 }
//               },
//               total: {
//                 show: true,
//                 showAlways: true,
//                 label: 'Total Items',
//                 // Keep the styling configurations consistent
//                 fontSize: '14px',
//                 fontWeight: 500,
//                 color: '#666',
//                 formatter: function (w) {
//                   // Safely falls back to summing the config series array
//                   const series = w.globals.seriesTotals || w.config.series || [];
//                   return series.reduce((a, b) => a + b, 0);
//                 }
//               }
//             }
//           }
//         }
//       },

//       tooltip: {
//         enabled: true,
//         y: {
//           formatter: function (val) {
//             return `${val} Items`;
//           }
//         }
//       },

//       legend: {
//         position: 'bottom'
//       }
//     };

//     // const chart = new ApexCharts(chartRef.current, options);
//     // chart.render();
//     chartInstance.current = new ApexCharts(chartRef.current, options);
//     chartInstance.current.render();

//     //   return () => {
//     //     chart.destroy();
//     //   };
//     // }, []);

//     return () => {
//       if (chartInstance.current) {
//         chartInstance.current.destroy();
//         chartInstance.current = null;
//       }
//     };
//   }, [data]);

//   return (
//     <div style={{ width: '100%', maxWidth: '500px', margin: '0 auto' }}>
//       <div ref={chartRef}></div>
//     </div>
//   );
// };

// export default DonutChart;



const BarChart = ({ data }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (
      !data ||
      typeof data !== "object" ||
      (!data["0-3 Days"] &&
        !data["3-5 Days"] &&
        !data["> 5 Days"])
    ) {
      return;
    }

    if (chartInstance.current) {
      chartInstance.current.destroy();
      chartInstance.current = null;
    }

    const options = {
      series: [
        {
          name: "PR Count",
          data: [
            data["0-3 Days"] || 0,
            data["3-5 Days"] || 0,
            data["> 5 Days"] || 0,
          ],
        },
      ],

      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: true,
        },
      },

      grid: {
        padding: {
          left: 20,   // Increase this value (20-40)
          right: 10,
        },
      },

      colors: ["#008FFB", "#00E396", "#FEB019"],

      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "45%",
          borderRadius: 6,
          distributed: true,
        },
      },

      xaxis: {
        categories: ["0 - 3 Days", "3 - 5 Days", "> 5 Days"],
      },

      yaxis: {
        title: {
          text: "",
        },
      },

      dataLabels: {
        enabled: true,
      },

      tooltip: {
        y: {
          formatter: function (val) {
            return val + " Items";
          },
        },
      },

      legend: {
        show: false,
      },
    };

    chartInstance.current = new ApexCharts(chartRef.current, options);
    chartInstance.current.render();

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
        chartInstance.current = null;
      }
    };
  }, [data]);

  return (
    <div style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
      <div ref={chartRef}></div>
    </div>
  );
};

export default BarChart;



